import React from 'react';
import clsx from 'clsx';


interface SuccessAlertProps {
    message: string;
    className?: string;
    'aria-live'?: 'polite' | 'assertive';
}

export const SuccessAlert: React.FC<SuccessAlertProps> = ({ message, className, 'aria-live': ariaLive = 'polite' }) => {

    return (
        <div role="alert" aria-live={ariaLive}
            className={clsx(
                'rounded-lg border px-4 py-3 w-full',
                'bg-green-50 border-green-200 text-green-800',
                className
            )}
        >
            <div className="flex items-start gap-2">
                <div className="flex-1">
                    <span className="text-sm">{message}</span>
                </div>
            </div>
        </div>
    );
};